'use strict';

import _uniqueId from 'lodash/uniqueId';

import {
	SET_GLOBAL_RAW_INGREDIENT_MODAL,
	UPDATE_GLOBAL_RAW_INGREDIENT,
	RESET_STATE,
	ADD_BATCH_LIST,
	EDIT_BATCH_LIST_ITEM,
	REMOVE_BATCH_LIST_ITEM,
	ADD_BATCH_LIST_ITEM_ROW
} from './globalRawIngredients.actions';

const defaultState = {
	data: {
		globalRawIngredient: {},
		batchList: [
			{
				identifier: _uniqueId('row-'),
				name: '',
				description: ''
			}
		]
	}
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
	case SET_GLOBAL_RAW_INGREDIENT_MODAL: {
		return {
			...state,
			data: {
				globalRawIngredient: payload
			}
		};
	}

	case UPDATE_GLOBAL_RAW_INGREDIENT: {
		return {
			...state,
			data: {
				globalRawIngredient: {
					...state.data.globalRawIngredient,
					...payload
				}
			}
		};
	}

	case RESET_STATE: {
		return defaultState;
	}

	case ADD_BATCH_LIST: {
		return {
			...state,
			data: {
				...state.data,
				batchList: payload
			}
		};
	}

	case EDIT_BATCH_LIST_ITEM: {
		return {
			...state,
			data: {
				...state.data,
				batchList: state.data.batchList.map(entry => {
					if (entry.identifier === payload.identifier) return payload;
					return entry;
				})
			}
		};
	}

	case REMOVE_BATCH_LIST_ITEM: {
		return {
			...state,
			data: {
				...state.data,
				batchList: state.data.batchList.filter(
					entry => entry.identifier !== payload
				)
			}
		};
	}

	case ADD_BATCH_LIST_ITEM_ROW: {
		return {
			...state,
			data: {
				...state.data,
				batchList: [
					...state.data.batchList,
					{
						...defaultState.data.batchList[0],
						identifier: _uniqueId('row-')
					}
				]
			}
		};
	}

	default:
		return state;
	}
}

export default reducer;
